/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { CleanIconButton } from '@neo4j-ndl/react';
import { CodePreview } from '@neo4j-ndl/react/ai';
import {
  PencilSquareIconOutline,
  PlayCircleIconOutline,
} from '@neo4j-ndl/react/icons';

const cypherCode = `SHOW [ALL|BUILT IN|USER DEFINED] FUNCTION[S] EXECUTABLE BY
username
[YIELD { * | field[, ...] } [ORDER BY field ...`;

export const Component = () => {
  return (
    <CodePreview
      code={cypherCode}
      language="cypher"
      label="write"
      headerActions={
        <>
          <CleanIconButton
            variant="neutral"
            description="Send to Query"
            size="small"
          >
            <PencilSquareIconOutline />
          </CleanIconButton>
          <CleanIconButton
            variant="neutral"
            description="Run in Query"
            size="small"
          >
            <PlayCircleIconOutline />
          </CleanIconButton>
        </>
      }
    />
  );
};

export default Component;
